import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { GetLocalStroge } from '../functions/local-storage.function';
import { CommonService } from '../services/common.service';
import { MENUITEMSIDENAV } from '../../core/globals/menu-item-sidenav';

/**
 * This service use for check user is login or not
 * .if not login redirect to login page.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {


  constructor(
    public router: Router,
    private commonService: CommonService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const { token } = GetLocalStroge('login');

    if (!token) {
      this.router.navigate(['/login']);
      this.commonService.showErrorSnackBar('دسترسی غیر مجاز دوباره وارد شوید');
      return false;
    } else if (GetLocalStroge('login').otherRole) {
      const destination = MENUITEMSIDENAV.find(x => x.routerLink === state.url);
      if (destination.otherRoles.find(x => x === GetLocalStroge('login').otherRole)) {
        return true;
      } else {
        if (GetLocalStroge('login').otherRole === 1) {
          this.router.navigate(['']);
        } else {
          this.router.navigate(['role']);
        }
        return false;
      }

    }
    return true;
  }
}

